import React, { useCallback, useEffect, useRef } from 'react';
import { Form, SingleSelect } from '@loanpal/lumos__core';
import { object, string } from "yup";
import { Box } from "theme-ui";

function isDropdownOpen(menu) {
  if (!menu) return false;
  const style = window.getComputedStyle(menu);
  return style.padding !== "0px" || style.borderWidth !== "0px";
}

function adjustOpenMenuPosition(container) {
  const menu = container?.querySelector('ul[role="listbox"]');
  const button = container?.querySelector('button[type="button"]');
  if (!menu || !button || !isDropdownOpen(menu)) return;

  const rect = button.getBoundingClientRect();
  const maxMenuHeight = Math.min(320, window.innerHeight * 0.45);
  const spaceBelow = window.innerHeight - rect.bottom - 8;
  const spaceAbove = rect.top - 8;

  menu.style.position = "fixed";
  menu.style.width = `${rect.width}px`;
  menu.style.left = `${rect.left}px`;
  menu.style.zIndex = "99999";
  menu.style.overflowY = "auto";

  if (spaceBelow >= 180 || spaceBelow >= spaceAbove) {
    menu.style.top = `${rect.bottom}px`;
    menu.style.maxHeight = `${Math.min(maxMenuHeight, Math.max(spaceBelow, 120))}px`;
  } else {
    const height = Math.min(maxMenuHeight, Math.max(spaceAbove, 120));
    menu.style.top = `${Math.max(8, rect.top - height)}px`;
    menu.style.maxHeight = `${height}px`;
  }
}

const Users = ({
  usersItems,
  setInput,
  sUser,
  readOnly,
  allowSearch = false,
  viewportAwareMenu = false,
}) => {
  const containerRef = useRef(null);

  const scheduleMenuPosition = useCallback(() => {
    if (!viewportAwareMenu || !containerRef.current) return;
    requestAnimationFrame(() => {
      adjustOpenMenuPosition(containerRef.current);
    });
  }, [viewportAwareMenu]);

  useEffect(() => {
    if (!viewportAwareMenu || !containerRef.current) return undefined;

    const container = containerRef.current;
    const button = container.querySelector('button[type="button"]');
    button?.addEventListener("click", scheduleMenuPosition);
    window.addEventListener("scroll", scheduleMenuPosition, true);
    window.addEventListener("resize", scheduleMenuPosition);

    return () => {
      button?.removeEventListener("click", scheduleMenuPosition);
      window.removeEventListener("scroll", scheduleMenuPosition, true);
      window.removeEventListener("resize", scheduleMenuPosition);
    };
  }, [viewportAwareMenu, usersItems, scheduleMenuPosition]);

  const schema = object({
    user: string().required('Select User')
  });

  const initialValues = {
    user: sUser ? sUser.id : ""
  };

  const wrapSetInput = (value) => {
    setInput(value);
  }

  return (
    <>
    {usersItems &&
        <>
        <Form onSubmit={console.log} validationSchema={schema} initialValues={initialValues}>
          <Box ref={containerRef} sx={{ width: "100%", mr: 5, mt: 2 }}>
            <SingleSelect
              dangerouslyOnChange={(e) => {
                  wrapSetInput(e);
              }}
              name="user"
              label={`Existing Users`}
              items={usersItems}
              readOnly={!!readOnly}
              allowSearch={allowSearch}
              placeholder="Search or select a user"
            />
          </Box>
      </Form>
      </>
    }
    </>
  )
}

export default Users;